import { BaseHit, Widget } from 'instantsearch.js';
import BaseTypesenseSearch from '../typesense-search';
import { getHits } from '../common-widgets';
import { HitsTemplates } from 'instantsearch.js/es/widgets/hits/hits';
import { configure } from 'instantsearch.js/es/widgets';
import { getRessourcePagination } from '../ressource/ressource-widgets';

interface IPage {
    id: string;
    title: string;
    excerpt: string;
    permalink: string;
    content: string
}

export default class PageListing extends BaseTypesenseSearch {
  private resultHitsContainer: HTMLDivElement | null = null;
  constructor() {
    super();
  }

  getHitTemplates(): HitsTemplates {
    return {
      item(data, { html }) {
        const {
          title,
          content,
          permalink,
          excerpt,
        } = data as unknown as BaseHit & IPage;

        return html`
            <a
                href="${permalink}"
                class="card card-page card-link"
                style="--card-background-color: white;"
                title="${title}"
            >
                <div class="card-content">
                <h3 class="card-title">${title}</h3>
                <div class="card-text-wrapper">
                    <div class="card-text">${excerpt || content}</div>
                    <span class="btn btn-simple btn-primary">
                    En savoir plus
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M1.33319 10.0001L1.3331 8.6668H12.1144L9.48123 6.03363L10.424 5.09082L14.6667 9.33347L10.424 13.5761L9.48123 12.6333L12.1144 10.0001L1.33319 10.0001Z"
                            fill="currentColor"></path>
                    </svg>
                    </span>
                </div>
                </div>
            </a>
        `;
      },
    };
  }

  getWidgets() {
    return [
      this.resultHitsContainer ? getHits(this.resultHitsContainer, {
        root: '',
        list: '',
      }, this.getHitTemplates()) : null,
      this.configureParams ? configure(this.configureParams) : null,
      this.paginationContainer ? getRessourcePagination(this.paginationContainer) : null,
    ].filter(Boolean) as Widget[];
  }


  init() {
    this.resultHitsContainer = this.querySelector('.result-hits');

    this.searchInstance?.start();
    this.searchInstance?.addWidgets(this.getWidgets());
  }

  connectedCallback() {
    setTimeout(() => {
      super.initSearchInstance();
      this.init();
    });
  }
}
